module.exports = __webpack_public_path__ + "static/media/infoJumbo3.308bddde.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/gressel/images/infoJumbo3.png
// module id = 541
// module chunks = 0